import { combineReducers } from 'redux';
import type { ThingsToDoShelfTag, ThingsToDoShelfHeader } from '@/shared/types';
import {
    FETCH_TTD_SHELF_DATA,
    FETCH_TTD_SHELF_DATA_SUCCESS,
    FETCH_TTD_SHELF_DATA_FAILURE,
} from './actions';

const header = (
    state = { placeName: '', url: '' },
    { type, payload }: { type: string; payload: { header: ThingsToDoShelfHeader } },
): ThingsToDoShelfHeader => {
    if (type === FETCH_TTD_SHELF_DATA || type === FETCH_TTD_SHELF_DATA_FAILURE) {
        return { placeName: '', url: '' };
    }

    if (type === FETCH_TTD_SHELF_DATA_SUCCESS) {
        return payload?.header;
    }

    return state;
};

const tags = (
    state = [],
    { type, payload }: { type: string; payload?: { tags: ThingsToDoShelfTag[] } },
): ThingsToDoShelfTag[] => {
    if (type === FETCH_TTD_SHELF_DATA || type === FETCH_TTD_SHELF_DATA_FAILURE) {
        return [];
    }

    if (type === FETCH_TTD_SHELF_DATA_SUCCESS) {
        return payload?.tags ?? [];
    }

    return state;
};

export const thingsToDoShelfReducer = combineReducers({
    header,
    tags,
});
